import classNames from 'classnames';
import React from 'react';

import { ProviderSearch } from '../provider-search';
import * as styles from './provider-search-container.module.css';

interface Analytics {
	enableGA4: boolean;
	ga4Event: { name: string };
}

interface ProviderSearchContainerProps {
	abTestId: string;
	ctaAnalytics: Analytics;
	providerSearch: {
		insuranceVisibility: boolean;
		locationVisibility: boolean;
		sessionTypeVisibility: boolean;
		servicesVisibility: boolean;
	};
	shouldOverlapSiblingModule: boolean;
}

export function ProviderSearchContainer({
	abTestId,
	ctaAnalytics,
	providerSearch,
	shouldOverlapSiblingModule,
}: ProviderSearchContainerProps) {
	const {
		insuranceVisibility,
		locationVisibility,
		sessionTypeVisibility,
		servicesVisibility,
	} = providerSearch || {};

	return (
		<div
			className={classNames(
				shouldOverlapSiblingModule && styles.overlapSibling,
				styles.container
			)}
		>
			<ProviderSearch
				abTestId={abTestId}
				ctaAnalytics={ctaAnalytics}
				insuranceVisibility={insuranceVisibility}
				locationVisibility={locationVisibility}
				servicesVisibility={servicesVisibility}
				sessionTypeVisibility={sessionTypeVisibility}
			/>
		</div>
	);
}
